import React from 'react';
import { useSelector } from 'react-redux';
import { selectConfigFromBootstrap } from 'store/slice/bootstrap';
import { isSupportedLanguage } from 'core/window/bootstrapConfig';
import { measureLanguageNotSupported } from 'store/api/measurements/homePageMeasurements';
import ErrorModal from 'component/common/ErrorModal/ErrorModal';

export const LanguageNotSupportedErrorModal: React.FC<{}> = (props) => {
    const [showNotSupportedLanguageErrorModel, setShowNotSupportedLanguageErrorModel] = React.useState(true);
    const config = useSelector(selectConfigFromBootstrap);
    const languageSupported = isSupportedLanguage(config);

    if (!languageSupported) {
        measureLanguageNotSupported(config.language.cultureCode, config.pageConfig.pageTypeId, config);
    }

    return (
        <ErrorModal
            key="not-supported-language-error-modal"
            elementName="activities-not-supported-language-error-modal"
            showModal={showNotSupportedLanguageErrorModel && !languageSupported}
            message={config.cms[142439]}
            buttonText={config.cms[126815]}
            onButtonClick={() => setShowNotSupportedLanguageErrorModel(false)}
        />
    );
};
LanguageNotSupportedErrorModal.displayName = 'LanguageNotSupportedErrorModal';
